(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("clsx"), require("react"), require("styled-components"), require("react-dom"), require("lodash"));
	else if(typeof define === 'function' && define.amd)
		define(["clsx", "React", "styled-components", "ReactDOM", "lodash"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("clsx"), require("react"), require("styled-components"), require("react-dom"), require("lodash")) : factory(root["clsx"], root["React"], root[undefined], root["ReactDOM"], root["_"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, (__WEBPACK_EXTERNAL_MODULE__9894__, __WEBPACK_EXTERNAL_MODULE__156__, __WEBPACK_EXTERNAL_MODULE__540__, __WEBPACK_EXTERNAL_MODULE__9318__, __WEBPACK_EXTERNAL_MODULE__6252__) => {
return 